import { reduxForm } from 'redux-form';

import Form from '../Components/Form';

import validate from './validate';
import warn from './warn';
import onSubmit from './onSubmit';
import onSubmitFail from './onSubmitFail';

export const FORM_NAME = 'EmailOrderAcknowledgement';

const formConfig = {
  form: FORM_NAME,
  validate,
  warn,
  onSubmit,
  onSubmitFail
}

export default reduxForm(formConfig)(Form);
